<template>
  <div>
    <h3>Natureza e Áreas</h3>

    <b-form-group label="Áreas da Oportunidade:">
      <SelectArea v-model="oportunidade.areas" :multiple="true" />
      <b-form-invalid-feedback :state="validateState('areas')">
        <span v-if="!$v.oportunidade.areas.required"
          >Áreas da Oportunidade é um campo obrigatório.</span
        >
      </b-form-invalid-feedback>
    </b-form-group>

    <base-input label="Natureza Jurídica:" :show-warning="revisao('programa_atende_a')">
      <SelectTiposInstituicoes v-model="oportunidade.instituicoes_tipos" />
      <b-form-invalid-feedback :state="validateState('instituicoes_tipos')">
        <span v-if="!$v.oportunidade.instituicoes_tipos.required"
          >Natureza Jurídica é um campo obrigatório.</span
        >
      </b-form-invalid-feedback>
    </base-input>

    <h3>Estados e Municípios</h3>
    <b-form-group label="Estados:">
      <SelectMultiEstado v-model="oportunidade.estados" />
    </b-form-group>

    <b-form-group label="Municípios:">
      <SelectMultiMunicipio v-model="oportunidade.municipios" />
    </b-form-group>

    <h3>ODS</h3>
    <b-form-group>
      <Ods v-model="oportunidade.ods" />
    </b-form-group>
  </div>
</template>

<script>
import { mapState } from "vuex";
import SelectArea from "@/modules/areas/Components/SelectArea.vue";
import SelectMultiMunicipio from "@/modules/municipios/Components/SelectMultiMunicipio";
import SelectMultiEstado from "@/modules/municipios/Components/SelectMultiEstado";
import Ods from "@/components/Form/Ods.vue";
import SelectTiposInstituicoes from "@/modules/tipos_instituicoes/Components/SelectTiposInstituicoes.vue";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import BaseInput from "./BaseInput.vue";

export default {
  mixins: [validationMixin],

  components: {
    SelectArea,
    SelectMultiMunicipio,
    SelectMultiEstado,
    Ods,
    SelectTiposInstituicoes,
    BaseInput,
  },
  validations: {
    oportunidade: {
      instituicoes_tipos: {},
      areas: {},
    },
  },
  computed: {
    ...mapState("oportunidades", ["oportunidade"]),
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.oportunidade[name];
      return $dirty ? !$error : null;
    },
    isValid() {
      this.$v.oportunidade.$touch();
      return !this.$v.oportunidade.$anyError;
    },
    revisao(campo) {
      if (!this.oportunidade || !this.oportunidade.campos_revisao) return false;
      return this.oportunidade.campos_revisao.some(
        (item) => item.campo === campo
      );
    },
  },
};
</script>

<style></style>
